import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GrocyDashboardComponent } from './dashboard/components/dashboard/dashboard.component';

const routes: Routes = [
  { path: '', component: GrocyDashboardComponent },
  {
    path: 'journal',
    loadChildren: () => import('./journal/journal.module').then(m => m.GrocyJournalModule),
  },
  {
    path: 'plants',
    loadChildren: () => import('./plants/plants.module').then(m => m.GrocyPlantsModule),
  },
  {
    path: 'products',
    loadChildren: () => import('./products/products.module').then(m => m.GrocyProductsModule),
  },
  {
    path: 'seeds',
    loadChildren: () => import('./seeds/seeds.module').then(m => m.GrocySeedsModule),
  },
  {
    path: 'shopping-lists',
    loadChildren: () => import('./shopping-lists/shopping-lists.module').then(m => m.GrocyShoppingListsModule),
  },
  {
    path: 'stock',
    loadChildren: () => import('./stock/stock.module').then(m => m.GrocyStockModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GrocyRoutingModule {}
